module.exports = __webpack_public_path__ + "static/img/290.5a60a21d.png";